export const roles = {
	MPC: 'PARTSEXL.MPCUser',
	HQ: 'PARTSEXL.HQUser',
	RETAILER: 'PARTSEXL.RETAILER',
};
